import "core-js/modules/es.regexp.exec.js";
import Platform from './Platform';
import { isMiniprogram, getUrlParams } from '../utils/utils';
import compareVersion from "../utils/compareVersion";
import { getCookie } from "../utils/cookies";
import ZLJAdapter from '../adapter/ZLJAdapter';
import ZZAdapter from '../adapter/ZZAdapter';
import ZZSELLERAdapter from '../adapter/ZZSELLERAdapter';
import WubaAdapter from '../adapter/WubaAdapter';
import WechatAdapter from '../adapter/WechatAdapter';
import WechatMPAdapter from '../adapter/WechatMPAdapter';
import QQAdapter from '../adapter/QQAdapter';
import QQMPAdapter from '../adapter/QQMPAdapter';
import BaiduMPAdapter from '../adapter/BaiduMPAdapter';
import GAdapter from '../adapter/GAdapter';
import ZZHunterAdapter from '../adapter/ZZHunterAdapter';
import ZZYigeAdapter from '../adapter/ZZYigeAdapter';
import ToutiaoAdapter from '../adapter/ToutiaoAdapter';
import KuaishouAdapter from '../adapter/KuaishouAdapter';
import KrakenAdapter from '../adapter/KrakenAdapter';
import MAdapter from '../adapter/MAdapter'; // 找靓机app的旧webview
// 一定要放在转转app前面，正则判断的问题，待以后修复

export var zlj = new Platform({
  is: /zhaoliangji[^-]/g,
  adapter: ZLJAdapter,
  log: true,
  name: 'zlj'
}); // 找靓机app老的webview，但是ua写错的情况

export var zljOld = new Platform({
  is: function is() {
    return /zhaoliangji-v2/g.test(navigator.userAgent);
  },
  adapter: ZLJAdapter,
  log: true,
  name: 'zlj'
}); // 找靓机app的新webview

export var zljNew = new Platform({
  is: function is() {
    return /zhaoliangji-v2/g.test(navigator.userAgent) && (getUrlParams()['needNewWebview'] == '1' || getUrlParams()['needNewWebView'] == '1' || compareVersion(getCookie("v"), "9.1.10") >= 0);
  },
  adapter: ZZAdapter,
  log: true,
  name: 'zlj',
  isNewWebview: true
}); // 转转app

export var zz = new Platform({
  is: /58ZhuanZhuan/g,
  adapter: ZZAdapter,
  log: true,
  name: 'zz',
  scheme: 'zhuanzhuan://',
  isApp: true
}); // 转转卖家app

export var zzseller = new Platform({
  is: /ZhuanZhuanSeller$/g,
  adapter: ZZSELLERAdapter,
  log: true,
  name: 'zzseller',
  scheme: 'zhuanzhuanseller://',
  isApp: true
}); // 转转门店端app

export var zzstore = new Platform({
  is: /zzstore|offlinestorecomplex/g,
  adapter: ZZAdapter,
  // 共用 ZZAdapter
  log: true,
  name: 'zzstore',
  isApp: true
}); // 58app

export var app58 = new Platform({
  is: /WUBA/g,
  adapter: WubaAdapter,
  log: true,
  name: 'app58',
  isApp: true
}); // 微信浏览器，非微信小程序中

export var wechat = new Platform({
  is: function is() {
    return /MicroMessenger/g.test(navigator.userAgent) && !isMiniprogram() && !/wxwork/g.test(navigator.userAgent);
  },
  adapter: WechatAdapter,
  log: 'wx',
  name: 'wechat'
}); // 微信浏览器，在微信小程序中

export var miniprogram = new Platform({
  is: isMiniprogram,
  adapter: WechatMPAdapter,
  log: true,
  name: 'miniprogram'
}); // 企业微信

export var wxwork = new Platform({
  is: function is() {
    return /wxwork/g.test(navigator.userAgent) && !isMiniprogram();
  },
  adapter: WechatAdapter,
  log: 'wxwork',
  name: 'wxwork'
}); // 手机qq

export var qq = new Platform({
  is: /QQ\//g,
  adapter: QQAdapter,
  name: 'qq'
}); // 手机qq小程序

export var qqMP = new Platform({
  is: /QMA\//g,
  adapter: QQMPAdapter,
  name: 'qqmp'
}); // 百度小程序

export var baiduMP = new Platform({
  is: /baiduboxapp\//g,
  adapter: BaiduMPAdapter,
  name: 'baidump'
}); // 招商银行

export var cmblife = new Platform({
  is: /cmblife/g,
  adapter: MAdapter,
  log: true,
  name: 'cmblife'
}); // 腾讯电脑管家

export var qqmgr = new Platform({
  is: function is() {
    return /wesecure/g.test(navigator.userAgent) || /theme=qqmgr/g.test(location.href);
  },
  adapter: MAdapter,
  name: 'qqmgr'
}); // 切克app

export var checkapp = new Platform({
  is: /checkapp/g,
  adapter: GAdapter,
  log: true,
  name: 'checkapp',
  scheme: 'zzcheck://'
}); // 采货侠app

export var zzhunter = new Platform({
  is: /zzhunter|crmHunter|thunderHunter/ig,
  adapter: ZZHunterAdapter,
  log: true,
  name: 'zzhunter',
  scheme: 'zzhunter://'
}); // 一格app

export var zzyige = new Platform({
  is: /yigeapp/g,
  adapter: ZZYigeAdapter,
  log: true,
  name: 'zzyige',
  scheme: 'zzyige://'
}); // 头条小程序

export var toutiao = new Platform({
  is: function is() {
    return /toutiaomicroapp/ig.test(navigator.userAgent.toLowerCase());
  },
  adapter: ToutiaoAdapter,
  log: 'tt',
  name: 'toutiao'
}); // 快手小程序

export var kuaishou = new Platform({
  is: function is() {
    return /kuaishou/ig.test(navigator.userAgent.toLowerCase()) || window.ks;
  },
  adapter: KuaishouAdapter,
  log: 'ks',
  name: 'kuaishou'
}); // 北海

export var kraken = new Platform({
  is: function is() {
    return !!window.kraken;
  },
  adapter: KrakenAdapter,
  log: 'kraken',
  name: 'kraken'
});
export var m = new Platform({
  is: function is() {
    return false;
  },
  adapter: MAdapter,
  log: true,
  name: 'm'
});